import { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import { projections } from "config/projections";
import { useTranslation } from "react-i18next";
import { Layer } from "types/types";
import { getShapefileUrl } from "utils/GeoserverUtils";

interface Props {
  layer: Layer;
}
export function VectorLayerDownload(props: Props) {
  const { layer } = props;
  const { t } = useTranslation();
  const availableProjections = projections;
  const [firstProjection] = availableProjections;
  const [projectionUrl, setProjectionUrl] = useState(firstProjection.url);

  function onChange(e: SelectChangeEvent<string>) {
    setProjectionUrl(e.target.value);
  }

  return (
    <StyledBox>
      <FormControl fullWidth>
        <Select value={projectionUrl} onChange={onChange}>
          {availableProjections.map((proj) => (
            <MenuItem key={proj.id} value={proj.url}>
              {proj.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        component={Link}
        href={getShapefileUrl(layer.geoserverLayer, projectionUrl)}
        target="_blank"
        variant="contained"
      >
        {t("label.downloadShapefile")}
      </Button>
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  .MuiInputBase-input {
    padding-top: ${({ theme }) => theme.spacing(1)};
    padding-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;
